<template>
  <div class="flex" :class="{'justify-center' : centered}">
    <a href="https://www.facebook.com/Onestilaw/" target="_blank" class="media-icon mr-2">
      <font-awesome-icon :icon="['fab', 'facebook-square']" />
    </a>
    <a href="https://pt.linkedin.com/company/onestilaw" target="_blank" class="media-icon mr-2">
      <font-awesome-icon :icon="['fab', 'linkedin-in']" />
    </a>
    <a href="https://www.youtube.com/onestiadvogados" target="_blank" class="media-icon mr-2">
      <font-awesome-icon :icon="['fab', 'youtube']" />
    </a>
    <a href="https://x.com/Onestilaw/" target="_blank" class="media-icon mr-2">
      <font-awesome-icon :icon="['fab', 'x-twitter']" />
    </a>
    <a href="https://www.yelp.com.br/biz/onesti-advogados-s%C3%A3o-paulo-2" target="_blank" class="media-icon">
      <font-awesome-icon :icon="['fab', 'yelp']" />
    </a>
  </div>
</template>
<script>
export default {
  name: 'SocialMediaIcons',
  props: {
    centered: Boolean
  }
}
</script>
<style scoped lang="sass">
@tailwind utilities

.media-icon
  @apply text-2xl text-grey cursor-pointer
  transition: color .2s
  &:hover
    @apply text-white
</style>
